import Vue from 'vue'
import App from './App.vue'
import store from "./store/index.js"
import router from "./router/index.js"

Vue.config.productionTip = false

// fullpage组件
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';
Vue.use(VueFullPage);

// 饿了么ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// markdown显示高亮
import 'highlight.js/styles/github.css'
// 其他元素使用 github 的样式
import 'github-markdown-css'

// 挂载this.$utils
import install from "./utils/index"
Vue.use(install)


new Vue({
	components: {
		App
	},
	router,
	store,
	template: '<App/>'
}).$mount('#app')

document.title = "机器人IDE"
